import React from 'react';

var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux} from '../../flux';

import {Link} from 'react-router';

var ActivateUser = React.createClass({
	mixins: [FluxMixin, StoreWatchMixin("MainStore")],
	getStateFromFlux: function(){
		var flux = this.getFlux();
		return{
				activeUserError: flux.store("MainStore").activeUserError,
				activateUser: flux.store("MainStore").activateUser
		}
	},
	getInitialState: function(){
		return{
			token: "",
			userErr: false
		}
	},
	handleTokenChange: function(e){
		this.setState({token: e.target.value, userErr: false});
		this.getFlux().actions.clearLoginErrors();
	},
	sendClick: function(){
		if(this.state.token === ""){
			this.setState({userErr: true})
		} else {
			this.getFlux().actions.activeUser(false, this.state.token, this.state.activateUser.data);
		}
	},
	handleCloseClick: function(){
		this.getFlux().actions.activeUser(false);
	},
	render: function(){
		var userclass= "form__wrap__field", userErrMsg = "";
		if(this.state.activeUserError){
			userclass = "form__wrap__field error_field";
			userErrMsg = "Error: This Token is not exists.";
		}
		if(this.state.userErr){
			userclass = "form__wrap__field error_field";
			userErrMsg = "Error: Please enter your token.";
		}
		return(
			<div>
				<div className="modal__mask"> </div>
				<div className="onboarding__modalpop clearfix">
					<div className="modal__content modal--md">
					  <div className="modal__body forgot-password__container clearfix">
					    <div className="form__wrap">
					      <div className="form__wrap">
					        <div className="modal__header whole">
					            <h4 className="modal__header--title">Token</h4>
					            <p>Enter the token which was sent to your email. If you do not receive an email, check your spam folder, or try again.</p>
					            <p className="modal__header--tc-text"><i style={{"color":"#0072bc"}}></i></p>			 
					            <a href="javascript:void(0)" onClick = {this.handleCloseClick} className="modal__close"><i className="fa  fa-close"> </i></a>
					        </div>
					        <div className="form__wrap-inner whole">
					          <div className="whole">
							  	<div className={userclass}>
					          		<span className="error_list--text">{userErrMsg}</span>
					            	<input type="text" onChange = {this.handleTokenChange} value={this.state.token} placeholder="Token"/>
									<i className="fa fa-fw error_list--icon" aria-hidden="true" title="Copy to use exclamation-circle"></i>
								</div>
					          </div>
					        </div>
					        <div className="form__wrap-inner">
					          <div className="whole">
					          	<div className="forgot-password__btn">
					            	<button className="btn__lg bg-dark send_mail_btn" onClick = {this.sendClick}><span>Activate</span></button>
					           		{/* <Link to= "/" style = {{"textDecoration": "none", color: "black"}}><button className="btn__lg highlight back_to_login"><span>Back to Login</span></button></Link> */}
					            </div>
					          </div>
					        </div>				  
					      </div>				      
					    </div>
					  </div>
					</div>
				</div>
			</div>
		);
	}
});

export {ActivateUser}


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/ActivateUser.jsx
 **/